import {ITitleLayerItem} from "@ui/leafletCustom/titleLayer/types";

export const DEFAULT_DARK_LAYER = 'googleStreetsDark'
export const DEFAULT_LIGHT_LAYER = 'googleStreets'
export const openstreetmap = {
    label: 'Openstreetmap',
    url: 'http://tile.openstreetmap.org/{z}/{x}/{y}.png',
    maxZoom: 19,
}

export const openstreetmapDark = {
    label: 'Openstreetmap(dark)',
    url: 'http://tile.openstreetmap.org/{z}/{x}/{y}.png',
    maxZoom: 19,
}


const cartoVoyager = {
    label: 'Carto Voyager',
    url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png'
}


const cartoVoyagerGray = {
    label: 'Carto Voyager(gray)',
    url: 'http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
}


const cartoVoyagerDark = {
    label: 'Carto Voyager(dark)',
    url: 'http://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png',
}


const googleStreets = {
    label: 'Google Streets',
    url: 'http://mt0.google.com/vt/x={x}&y={y}&z={z}',
    maxZoom: 20,
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
};

const googleStreetsDark = {
    label: 'Google Streets(dark)',
    url: 'http://mt0.google.com/vt/x={x}&y={y}&z={z}',
    maxZoom: 20,
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
};


const googleHybrid = {
    label: 'Google Hybrid',
    url: 'http://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
    maxZoom: 20,
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
};

// const stadiaMapsDark = {
//     label: 'Stadia maps(dark)',
//     url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
//     maxZoom: 20,
// };


export const MAP_LAYERS: Record<string, ITitleLayerItem> = {
    openstreetmap,
    openstreetmapDark,
    cartoVoyager,
    cartoVoyagerDark,
    cartoVoyagerGray,
    googleStreets,
    googleStreetsDark,
    googleHybrid,
    // stadiaMapsDark,
};

